export function capitalise(str: string) : string {
  return typeof str !== 'string' ? str : str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
}

export function toTitleCase(str: string) : string {
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
